export default __webpack_public_path__ + "static/media/value-proposition-template.6f9646f5.pdf";